import { Routes } from '@angular/router';
import { permissionGuard } from '../../../core/auth/permission.guard';
import { GRC_PLATFORM_ENTITLEMENT } from '../grc-form.models';

const adminScope = { requiredScopes: ['admin'] as const };

export const GRC_INTEGRATION_ROUTES: Routes = [
  {
    path: 'grc/integration/sources',
    loadComponent: () => import('./grc-integration-sources.component').then(m => m.GrcIntegrationSourcesComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'grc.integration.sources.read',
      requiredEntitlement: GRC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  },
  {
    path: 'grc/integration/sources/:id',
    loadComponent: () => import('./grc-integration-source-detail.component').then(m => m.GrcIntegrationSourceDetailComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'grc.integration.sources.read',
      requiredEntitlement: GRC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  },
  {
    path: 'grc/integration/batches',
    loadComponent: () => import('./grc-integration-batches.component').then(m => m.GrcIntegrationBatchesComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'grc.integration.sources.read',
      requiredEntitlement: GRC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  },
  {
    path: 'grc/integration/parties/staging',
    loadComponent: () => import('./grc-integration-party-staging.component').then(m => m.GrcIntegrationPartyStagingComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'grc.integration.sources.manage',
      requiredEntitlement: GRC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  }
];
